import FieldValuesEditorView from "./FieldValuesEditorView";
import useFieldValuesEditor, { type FieldValuesSectionProps } from "./useFieldValuesEditor";

const FieldValuesSection = (props: FieldValuesSectionProps) => {
  const editor = useFieldValuesEditor(props);

  return <FieldValuesEditorView {...props} editor={editor} />;
};

export default FieldValuesSection;
